<template>
  <div>
    <b-modal
      id="modal_novo_itens"
      title="Adicionar Produto"
      ref="my-modal"
      size="lg"
      hide-footer
      modal-class="modal-add-product"
      @show="resetModal"
      @hidden="resetModal"
      scrollable
    >
      <!-- Client Info Bar -->
      <div v-if="getFormData && getFormData.cliente" class="client-info-bar">
        <div class="client-info">
          <feather-icon icon="UserIcon" size="16" />
          <div class="info-content">
            <span class="label">CLIENTE</span>
            <span class="value">{{ getFormData.cliente.clientenomeabreviado || 'Cliente' }}</span>
          </div>
        </div>

        <div class="order-info">
          <div class="info-item" v-if="getFormData.dataCapaPedido">
             <feather-icon icon="TagIcon" size="16" />
             <div class="info-content">
               <span class="label">TABELA</span>
               <span class="value">{{ getFormData.dataCapaPedido.tabelaprecoid || '-' }}</span>
             </div>
          </div>
          <div class="info-item">
            <feather-icon icon="ShoppingCartIcon" size="16" />
            <div class="info-content">
               <span class="label">ITENS</span>
               <span class="value">{{ itensTabela.length }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Seletor de tipo de busca -->
      <b-row class="mb-1 mt-1">
        <b-col md="12">
          <b-form-group label="Tipo de Busca:">
            <b-form-radio-group
              v-model="tipoBusca"
              :options="opcoesTypeBusca"
              @change="onTipoBuscaChange"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Busca por marca e categoria -->
      <b-row v-if="tipoBusca === 'marca-categoria'" class="gx-3 gy-2 align-items-center justify-content-center">
        <!-- Marca -->
        <b-col md="3">
          <b-form-group label="Marca">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingMarca" />
                <feather-icon
                  icon="TagIcon"
                  size="18"
                  :color="$store.state.intensPedido.setExisteMarca ? '#1f9d57' : '#ea5455'"
                  v-if="!getIsLoadingMarca"
                />
              </b-input-group-prepend>
              <b-form-select
                v-model="selected_cod_marca"
                :options="getEsMarcas"
                :state="$store.state.intensPedido.setExisteMarca"
                @change="limparCamposDependendes"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Categoria -->
        <b-col md="3">
          <b-form-group label="Categoria">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingCategoria" />
                <feather-icon
                  icon="ShoppingBagIcon"
                  size="18"
                  :color="$store.state.intensPedido.setExisteCategoria ? '#1f9d57' : '#ea5455'"
                  v-if="!getIsLoadingCategoria"
                />
              </b-input-group-prepend>
              <b-form-select
                v-model="selected_categoria"
                :options="getEsCategorias"
                :disabled="!selected_cod_marca || getIsLoadingCategoria || getIsLoadingReferencia || isLoadingAllData"
                :state="$store.state.intensPedido.setExisteCategoria"
                @change="limparReferencia"
              />
              <b-form-invalid-feedback
                v-show="!getIsLoadingCategoria && !$store.state.intensPedido.setExisteCategoria && selected_cod_marca"
                tooltip
              >
                A marca selecionada não possui categorias cadastradas.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Referência -->
        <!-- <b-col md="2">
          <b-form-group label="Referência">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="PackageIcon" size="18" />
              </b-input-group-prepend>
              <b-form-input
                v-model="busca_referencia"
                placeholder="Cód. da referência"
                :disabled="!selected_cod_marca || !selected_categoria || isLoadingAllData"
              />
            </b-input-group>
          </b-form-group>
        </b-col> -->

        <!-- Botão Buscar e Limpar -->
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="primary"
              block
              class="mt-1"
              :disabled="!selected_cod_marca || !selected_categoria || isLoadingAllData"
              @click="buscarReferencias"
            >
              <feather-icon icon="SearchIcon" size="18" class="mr-1" />
              Buscar
            </b-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="danger"
              block
              class="mt-1"
              @click="limparFiltros"
            >
              <feather-icon icon="TrashIcon" size="18" class="mr-1" />
              Limpar
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Busca por código de referência -->
      <b-row v-if="tipoBusca === 'codigo-referencia'" class="gx-3 gy-2 align-items-center justify-content-center">
        <b-col md="3">
          <b-form-group label="Código da Referência">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <b-spinner small variant="success" v-show="getIsLoadingReferencia" />
                <feather-icon icon="PackageIcon" size="18" v-if="!getIsLoadingReferencia" />
              </b-input-group-prepend>
              <b-form-input
                v-model="codigo_referencia_direto"
                placeholder="Digite o código da referência"
                :disabled="isLoadingAllData"
                @keyup.enter="buscarPorCodigoReferencia"
                @blur="trimCodigoReferencia"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="primary"
              block
              class="mt-1"
              :disabled="!codigo_referencia_direto || isLoadingAllData"
              @click="buscarPorCodigoReferencia"
            >
              <feather-icon icon="SearchIcon" size="18" class="mr-1" />
              Buscar
            </b-button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label=" ">
            <b-button
              variant="danger"
              block
              class="mt-1"
              @click="limparFiltros"
            >
              <feather-icon icon="TrashIcon" size="18" class="mr-1" />
              Limpar
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Totais -->
      <b-row class="justify-content-end mt-3">
        <b-col cols="auto" class="text-right">
          <p><strong>Total de Pedidos:</strong> {{ totalUnidades }}</p>
          <p>
            <strong>Total Valor:</strong>
            R$ {{ totalValor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
          </p>
        </b-col>
      </b-row>

      <!-- Loading -->
      <div v-if="isLoadingAllData" class="loading-indicator text-center my-2">
        <b-spinner small type="grow" class="mr-2"></b-spinner>
        Carregando mais itens...
      </div>

      <!-- Inserção de Itens -->
      <inserir-item-modal
        @update:grade-item="updatedGradeItens"
        @calcular-imposto="calcularImposto"
        @remove-item="handleRemoveItem"
      />

      <div class="modal-actions-footer">
        <div class="items-summary" v-if="itensTabela.length > 0">
          <span class="summary-count">{{ itensTabela.length }} item(s)</span>
          <span class="summary-separator">|</span>
          <span class="summary-total">{{ totalValor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
        </div>
        <div class="actions-buttons" :class="{ 'ml-auto': itensTabela.length === 0 }">
           <b-button variant="outline-secondary" @click="$refs['my-modal'].hide()">
             <feather-icon icon="XIcon" size="16" class="mr-50" />
             Cancelar
           </b-button>
           <b-button variant="success" @click="handleOk" :disabled="!novosItensAdicionados">
             <feather-icon icon="CheckIcon" size="16" class="mr-50" />
             Salvar
           </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BFormInput, BCol, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';
import ProductionItem from '@/views/app/operacoes/pedidosVendas/swipper/swipperItensProdutos.vue';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import axios from 'axios';
import ECommerceProductDetails from '@/views/app/CartECommerce/e-commerce-product-details/ECommerceProductDetails.vue';
import InserirItemModal from '@/views/app/operacoes/pedidosVendas/inserirItemModal.vue';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { getTotvsBaseUrl } from '@/utils/totvsApi';

export default {
  components: {
    InserirItemModal,
    ECommerceProductDetails,
    GradePedidos,
    BButton,
    BFormInput,
    BModal,
    BCol,
    BFormSelect,
    ProductionItem,
    BInputGroup,
    BInputGroupPrepend,
  },
  data() {
    return {
      isLoadingAllData: false,
      typeModal: null,
      selected_cod_marca: null,
      selected_categoria: null,
      selected_referencia: null,
      selected_embalagem: null,
      busca_referencia: '',
      valorUnitario: null,
      categoriasOptions: [],
      referenciasOptions: [],
      embalagensOptions: [],
      itensTabela: [],
      novosItensAdicionados: false,
      gradeAtual: [],
      arrayEmbalagens: [],
      isCalculandoImposto: false,
      tipoBusca: 'marca-categoria',
      codigo_referencia_direto: '',
      opcoesTypeBusca: [
        { text: 'Buscar por Marca e Categoria', value: 'marca-categoria' },
        { text: 'Buscar por Código de Referência', value: 'codigo-referencia' },
      ],
    };
  },
  mounted() {
    this.clearjsonTelaNovaPedido();
  },
  methods: {
    ...mapActions('intensPedido', [
      'itensMarcaPedido',
      'itensCategoriaPedido',
      'itensReferenciaPedido',
      'itensEmbalagemPedido',
      'itensdetalhes',
      'detalhesPedidoStored',
      'setListTabelaItens',
      'setIsLoadingReferencia',
      'setIsLoadingReferenciaRestante',
      'setjsonTelaNovaPedido',
      'clearjsonTelaNovaPedido',
      'clearModalItens',
      'buscaCorGradeItens',
      'buscarReferenciaPorCodigo',
    ]),
    ...mapActions('SLS_PedidosVendas', [
      'setItensTabelaPedido',
    ]),
    onTipoBuscaChange() {
      this.limparFiltros();
    },
    trimCodigoReferencia() {
      if (this.codigo_referencia_direto) {
        this.codigo_referencia_direto = this.codigo_referencia_direto.trim();
      }
    },
    async buscarPorCodigoReferencia() {
      this.codigo_referencia_direto = this.codigo_referencia_direto?.trim() || '';

      if (!this.codigo_referencia_direto) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Digite o código da referência',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.isLoadingAllData = true;
      await this.clearjsonTelaNovaPedido();

      try {
        const resultado = await this.buscarReferenciaPorCodigo({
          codReferencia: this.codigo_referencia_direto,
          tabelaPrecoId: this.getCapaPedido.tabelaprecoid,
        });

        if (resultado.success && Array.isArray(resultado.data) && resultado.data.length > 0) {
          const referenciasUnicas = [];
          const combinacoesVistas = new Set();

          for (const referencia of resultado.data) {
            const chaveUnica = `${referencia.CodReferencia}-${referencia.Referencia}`;

            if (!combinacoesVistas.has(chaveUnica)) {
              combinacoesVistas.add(chaveUnica);
              referenciasUnicas.push(referencia);
            }
          }

          if (referenciasUnicas.length === 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Informação',
                text: 'Nenhuma referência única encontrada',
                icon: 'InfoIcon',
                variant: 'info',
              },
            });
            return;
          }

          const referenciasParaProcessar = referenciasUnicas.map((ref) => ({
            CodReferencia: ref.CodReferencia,
            cod_marca: ref.cod_marca,
            cod_categ: ref.cod_categ,
          }));

          this.selected_cod_marca = referenciasUnicas[0].cod_marca;
          this.selected_categoria = referenciasUnicas[0].cod_categ;

          await this.buscarReferenciasProcessamento(referenciasParaProcessar);

          const mensagem = referenciasUnicas.length === 1
            ? `Referência encontrada: ${referenciasUnicas[0].Referencia}`
            : `${referenciasUnicas.length} referências encontradas`;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: mensagem,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Informação',
              text: resultado.message || 'Referência não encontrada',
              icon: 'InfoIcon',
              variant: 'info',
            },
          });
        }
      } catch (error) {
        console.error('Erro ao buscar por código de referência:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Erro ao buscar referência',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoadingAllData = false;
        await this.setIsLoadingReferenciaRestante(false);
      }
    },
    async buscarReferenciasProcessamento(referencias) {
      try {
        const apiCache = {};
        const urlsProcessadas = [];
        // Cache para simulação de impostos para evitar múltiplas chamadas iguais
        const impostoCache = {};

        const baseUrl = await getTotvsBaseUrl();

        const getFirstSkuFromGrade = (gradeData) => {
          try {
            const ordemKeys = [
              'itemExtrapq',
              'itemPequeno',
              'itemMedio',
              'itemGrande',
              'itemExtraGd',
              'itemSuperGd',
              'itemUltraGd',
              'itemUnico',
              'itemOutros',
            ];
            const registro = gradeData?.dsHBIgrade?.ttHBIgrade?.[0];
            if (!registro) return null;
            for (const k of ordemKeys) {
              if (registro[k] && registro[k] !== 0) return registro[k];
            }
            return null;
          } catch (e) {
            console.warn('Falha ao extrair primeiro SKU da grade', e);
            return null;
          }
        };

        const simularImpostoWithCache = async ({ skuId, precoBase }) => {
          if (!skuId || !precoBase) return null;

          const capaPedido = this.getCapaPedido || {};
          const enderecoEntrega = this.getEnderecoEntrega || {};

          const estabelecimentoid = capaPedido?.estabelecimentoId || '';
          const naturezaoperacaoid = capaPedido?.naturezaoperacaoidimposto || '';
          const canal_venda_id = capaPedido?.canalvendaid || '';
          const ufid = enderecoEntrega?.ufid || capaPedido?.ufid || '';
          const cidade = enderecoEntrega?.clienteenderecocidade || '';
          const isentoIE = capaPedido?.clienteisentoie ? 1 : 0;
          const tabelaprecoid = capaPedido?.tabelaprecoid || '';
          const condicaopagamentoid = Number(capaPedido?.condicaopagamentoid || 0);
          const nomeCliente = capaPedido?.clientenomeabreviado || '';

          if (!estabelecimentoid || !tabelaprecoid || !condicaopagamentoid || !nomeCliente) {
            return null;
          }

          const cacheKey = [skuId, precoBase, estabelecimentoid, naturezaoperacaoid, canal_venda_id, ufid, cidade, isentoIE, tabelaprecoid, condicaopagamentoid].join('|');
          if (impostoCache[cacheKey]) return impostoCache[cacheKey];

          try {
            const url = `${baseUrl}/simular-Impostos-novo-metodo`;
            const payload = {
              ttCabPedido: [
                {
                  'c-pr-cod-estabel': estabelecimentoid,
                  'c-pr-nome-abrev': nomeCliente,
                  'c-pr-nat-operacao': naturezaoperacaoid,
                  'c-pr-cod-canal-venda': canal_venda_id || '',
                  'c-pr-it-codigo': skuId,
                  'd-pr-quantidade': 1,
                  'd-pr-vl-preori-ped': precoBase,
                  'd-pr-per-des-item': 0.0,
                  'p-simulacao': 0,
                  'p-uf-ds': ufid,
                  'p-cidade-ds': cidade,
                  'p-contr-icms': isentoIE,
                  'p-tp-frete': 0,
                  'p-tp-tabpre': tabelaprecoid,
                  'p-cod-cond-pagto': condicaopagamentoid,
                  ttitempedido: [{ itCodigo: skuId }],
                },
              ],
            };
            const resp = await axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });
            const row = resp?.data?.ttRetornoImposto?.[0];
            if (!row) return null;
            const result = {
              precoComImposto: row['d-pr-unitario'] || null,
              baseIcms: row['d-pr-base-icms'] || null,
              valorIcms: row['d-pr-valor-icms'] || null,
              naturezaoperacaoidimposto: row['c-pr-nat-operacao'] || null,
            };
            impostoCache[cacheKey] = result;
            return result;
          } catch (e) {
            console.warn('Falha ao simular imposto (pré)', e);
            return null;
          }
        };

        const fetchGradeWithCache = async (url) => {
          if (urlsProcessadas.includes(url)) {
            return apiCache[url];
          }

          urlsProcessadas.push(url);

          try {
            const response = await axios.get(url);
            apiCache[url] = response.data;
            return response.data;
          } catch (error) {
            console.error(`Erro ao buscar: ${url}`, error);
            apiCache[url] = null;
            return null;
          }
        };

        const processedReferences = await Promise.all(
          referencias.map(async (ref) => {
            const refCode = ref.CodReferencia;
            try {
              const detalhes = await this.getDetalhesItem(refCode, ref.cod_marca, ref.cod_categ);

              if (detalhes && detalhes.Result) {
                const itemData = detalhes.Result.Result || {};

                // Ignorar respostas "vazias" (apenas Marca preenchida e demais blocos nulos)
                // Exemplo: { Marca: [...], imagens: null, Embalagens: null, corTamanho: null, tabelaPreco: null, familiaComercial: null }
                const isEmptyResponse = (
                  !itemData?.imagens
                  && !itemData?.Embalagens
                  && !itemData?.corTamanho
                  && !itemData?.tabelaPreco
                  && !itemData?.familiaComercial
                );
                const familiaArray = Array.isArray(itemData?.familiaComercial) ? itemData.familiaComercial : [];
                if (isEmptyResponse || familiaArray.length === 0) {
                  console.warn(`Referência ${refCode} sem dados detalhados úteis. Ignorando.`);
                  return null;
                }
                const tabelaPrecoArr = Array.isArray(itemData.tabelaPreco) ? itemData.tabelaPreco : null;
                const precoBaseNum = parseFloat(
                  tabelaPrecoArr?.[0]?.tabelapreco_item_preco ?? 0,
                );
                const precoBase = Number.isFinite(precoBaseNum) ? precoBaseNum : 0;

                if (!tabelaPrecoArr || tabelaPrecoArr.length === 0) {
                  console.log(`Atenção: Referência ${refCode} não possui tabela de preço válida.`);
                }

                const tamanhoProps = [
                  'itemMultiploExtraGd',
                  'itemMultiploExtrapq',
                  'itemMultiploGrande',
                  'itemMultiploMedio',
                  'itemMultiploOutros',
                  'itemMultiploPequeno',
                  'itemMultiploSuperGd',
                  'itemMultiploUltraGd',
                  'itemMultiploUnico',
                ];

                const embalagensProcessadas = await Promise.all(
                  (Array.isArray(itemData.Embalagens) ? itemData.Embalagens : []).map(async (embalagem) => {
                    try {
                      const gradeUrl = `${baseUrl}/grade/${refCode}/${embalagem.cdn_embalagem}/${this.getCapaPedido.clienteiderp}/${this.getCapaPedido.tabelaprecoid}`;
                      const gradeData = await fetchGradeWithCache(gradeUrl);

                      let itemMultiplo = 0;
                      if (gradeData?.dsHBIgrade?.ttHBIgrade?.[0]) {
                        const gradeTamanhos = gradeData.dsHBIgrade.ttHBIgrade[0];
                        for (const prop of tamanhoProps) {
                          if (gradeTamanhos[prop] && gradeTamanhos[prop] !== 0) {
                            itemMultiplo = gradeTamanhos[prop];
                            break;
                          }
                        }
                      }

                      return {
                        descricao_embalagem: embalagem.des_embalag,
                        cdn_embalagem: embalagem.cdn_embalagem,
                        grade: gradeData,
                        itemMultiplo,
                      };
                    } catch (e) {
                      console.warn('Falha ao carregar grade para embalagem', embalagem, e);
                      return {
                        descricao_embalagem: embalagem.des_embalag,
                        cdn_embalagem: embalagem.cdn_embalagem,
                        grade: null,
                        itemMultiplo: 0,
                      };
                    }
                  }),
                );

                const imagensArr = Array.isArray(itemData.imagens) ? itemData.imagens : [];
                const imagemPrincipal = imagensArr.find((img) => img.imagemPrincipal === 1);
                const caminhoImagemPrincipal = imagemPrincipal ? imagemPrincipal.caminho : null;

                let precoComImposto = null;
                let baseIcms = null;
                let valorIcms = null;
                let naturezaoperacaoidimposto = null;
                try {
                  const primeiraEmbalagemComGrade = embalagensProcessadas.find((e) => e?.grade?.dsHBIgrade?.ttHBIgrade?.[0]);
                  if (primeiraEmbalagemComGrade) {
                    const skuId = getFirstSkuFromGrade(primeiraEmbalagemComGrade.grade);
                    if (skuId) {
                      const imposto = await simularImpostoWithCache({ skuId, precoBase });
                      if (imposto) {
                        precoComImposto = imposto.precoComImposto;
                        baseIcms = imposto.baseIcms;
                        valorIcms = imposto.valorIcms;
                        naturezaoperacaoidimposto = imposto.naturezaoperacaoidimposto;
                      }
                    }
                  }
                } catch (e) {
                  console.warn('Falha na pré-simulação de imposto para referência', refCode, e);
                }

                const fam0 = itemData.familiaComercial?.[0] || {};
                const marca0 = itemData.Marca?.[0] || {};
                const formattedItem = {
                  item_id: fam0.item_id || 0,
                  item_name: fam0.Referencia || '',
                  item_price_base: (Number.isFinite(precoBase) ? precoBase : 0).toFixed(2),
                  item_price: (Number.isFinite(precoComImposto) && precoComImposto > 0 ? precoComImposto : (Number.isFinite(precoBase) ? precoBase : 0)).toFixed(2),
                  item_marca: marca0.des_marca || '',
                  cod_marca: marca0.cod_marca || this.selected_cod_marca || null,
                  referencia: fam0.CodReferencia || refCode,
                  imagens: imagensArr,
                  item_img_princial: caminhoImagemPrincipal,
                  embalagens: (embalagensProcessadas || []).filter(Boolean),
                  precoComImposto: Number.isFinite(precoComImposto) ? precoComImposto : null,
                  baseIcms,
                  valorIcms,
                  naturezaoperacaoidimposto,
                };

                await this.setjsonTelaNovaPedido(formattedItem);
                return formattedItem;
              }
            } catch (error) {
              console.error(`Erro ao processar referência ${refCode}:`, error);
            }
            return null;
          }),
        );

        console.log('Referências processadas:', processedReferences.filter((ref) => ref !== null));
      } catch (error) {
        console.error('Erro ao processar referências:', error);
        throw error;
      }
    },
    limparCamposDependendes() {
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.busca_referencia = '';
      this.getCategoriaPedido();
    },
    limparReferencia() {
      this.busca_referencia = '';
      this.selected_referencia = null;
      this.selected_embalagem = null;
    },
    async limparFiltros() {
      this.selected_cod_marca = null;
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.busca_referencia = '';
      this.codigo_referencia_direto = '';
      this.clearjsonTelaNovaPedido();
      this.clearModalItens();
      this.novosItensAdicionados = false;

      if (this.tipoBusca === 'marca-categoria') {
        await this.getMarcaPedido();
      }
    },
    async getMarcaPedido() {
      await this.itensMarcaPedido(this.getCapaPedido.tabelaprecoid);
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.busca_referencia = '';
    },
    async getCategoriaPedido() {
      await this.clearjsonTelaNovaPedido();
      if (this.selected_cod_marca) {
        await this.itensCategoriaPedido(this.selected_cod_marca);
        this.selected_categoria = null;
        this.selected_referencia = null;
        this.selected_embalagem = null;
      }
    },
    async buscarReferencias() {
      if (!this.selected_cod_marca || !this.selected_categoria) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Selecione marca e categoria antes de buscar referências',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      this.isLoadingAllData = true;
      await this.clearjsonTelaNovaPedido();

      try {
        await this.itensReferenciaPedido({
          selected_cod_marca: this.selected_cod_marca,
          selected_categoria: this.selected_categoria,
        });

        await this.setIsLoadingReferenciaRestante(true);

        this.selected_referencia = null;
        this.selected_embalagem = null;

        const referencias = this.$store.getters['intensPedido/getEsReferencias'];

        if (referencias && referencias.length > 0) {
          const referenciasParaProcessar = this.busca_referencia
            ? referencias.filter((ref) => {
              if (!ref.value) return false;
              const termo = this.busca_referencia.toLowerCase();
              const codRef = ref.value.codReferencia?.toString().toLowerCase() || '';
              const descRef = ref.value.referencia?.toLowerCase() || '';
              return codRef.includes(termo) || descRef.includes(termo);
            })
            : referencias;

          if (referenciasParaProcessar.length === 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Informação',
                text: 'Nenhuma referência encontrada com esse termo',
                icon: 'InfoIcon',
                variant: 'info',
              },
            });
            this.isLoadingAllData = false;
            await this.setIsLoadingReferenciaRestante(false);
            return;
          }

          const referenciasFormatadas = referenciasParaProcessar.map((ref) => ({
            CodReferencia: ref.value?.codReferencia,
          })).filter((ref) => ref.CodReferencia);

          await this.buscarReferenciasProcessamento(referenciasFormatadas);

          if (referenciasFormatadas.length === 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Informação',
                text: 'Nenhum resultado encontrado para a busca realizada',
                icon: 'InfoIcon',
                variant: 'info',
              },
            });
          } else {
            console.log('Referências encontradas:', referenciasFormatadas);
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Informação',
              text: 'Nenhuma referência encontrada para esta categoria',
              icon: 'InfoIcon',
              variant: 'info',
            },
          });
          this.isLoadingAllData = false;
          await this.setIsLoadingReferenciaRestante(false);
        }
      } catch (error) {
        console.error('Erro ao buscar referências:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao buscar referências',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoadingAllData = false;
        await this.setIsLoadingReferenciaRestante(false);
      }
    },
    async getDetalhesItem(familiaComercialId, cod_marca, cod_categ) {
      try {
        const params = {
          familiaComercialId,
          precoId: this.getCapaPedido.tabelaprecoid,
          codMarca: cod_marca || this.selected_cod_marca,
          codCateg: cod_categ || this.selected_categoria,
        };

        const response = await this.$store.dispatch('intensPedido/detalhesPedidoStored', params);

        if (!response) {
          console.warn('Nenhum detalhe encontrado para:', familiaComercialId);
          return {
            success: false,
            message: 'Nenhum detalhe encontrado',
          };
        }

        return {
          success: true,
          Result: response,
        };
      } catch (error) {
        console.error('Erro em getDetalhesItem:', error);
        return {
          success: false,
          error: error.message,
        };
      }
    },
    async calcularImposto(newItem) {
      Swal.fire({
        title: 'Calculando impostos',
        html: 'Por favor, aguarde...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      this.isCalculandoImposto = true;

      try {
        const capaPedido = this.getCapaPedido || {};
        const enderecoEntrega = this.getEnderecoEntrega || {};
        const estabelecimentoid = capaPedido?.estabelecimentoId || '';
        const naturezaoperacaoid = capaPedido?.naturezaoperacaoidimposto || '';
        const canal_venda_id = capaPedido?.canalvendaid || '';
        const ufid = enderecoEntrega?.ufid || capaPedido?.ufid || '';
        const cidade = enderecoEntrega?.clienteenderecocidade || '';
        const isentoIE = capaPedido?.clienteisentoie ? 1 : 0;
        const tabelaprecoid = capaPedido?.tabelaprecoid || '';
        const condicaopagamentoid = Number(capaPedido?.condicaopagamentoid || 0);
        const nomeCliente = capaPedido?.clientenomeabreviado || '';

        if (!estabelecimentoid || !nomeCliente || !tabelaprecoid || !condicaopagamentoid) {
          throw new Error('Não foi possível calcular impostos. Tente novamente.');
        }

        const baseUrl = await getTotvsBaseUrl();
        const url = `${baseUrl}/simular-Impostos-novo-metodo`;
        const data = {
          ttCabPedido: [
            {
              'c-pr-cod-estabel': estabelecimentoid,
              'c-pr-nome-abrev': nomeCliente,
              'c-pr-nat-operacao': naturezaoperacaoid,
              'c-pr-cod-canal-venda': canal_venda_id || '',
              'c-pr-it-codigo': newItem.item_id,
              'd-pr-quantidade': newItem.valor,
              'd-pr-vl-preori-ped': newItem.precoUnitario,
              'd-pr-per-des-item': 0.0000,
              'p-simulacao': 0,
              'p-uf-ds': ufid,
              'p-cidade-ds': cidade,
              'p-contr-icms': isentoIE,
              'p-tp-frete': 0,
              'p-tp-tabpre': tabelaprecoid,
              'p-cod-cond-pagto': condicaopagamentoid,
              ttitempedido: [{
                itCodigo: newItem.item_id,
              }],
            },
          ],
        };

        const response = await axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.data.ttRetornoImposto && response.data.ttRetornoImposto[0]) {
          const precoImposto = response.data.ttRetornoImposto[0]['d-pr-unitario'] || 0;
          const valorBaseIcms = response.data.ttRetornoImposto[0]['d-pr-base-icms'] || 0;
          const valorIcms = response.data.ttRetornoImposto[0]['d-pr-valor-icms'] || 0;
          const naturezaoperacaoidimposto = response.data.ttRetornoImposto[0]['c-pr-nat-operacao'] || 0;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Imposto calculado com sucesso!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          return {
            precoComImposto: precoImposto,
            baseIcms: valorBaseIcms,
            valorIcms,
            naturezaoperacaoidimposto,
          };
        }
        return null;
      } catch (error) {
        console.error('Erro ao calcular impostos:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: error.message || 'Erro ao calcular impostos',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });

        return null;
      } finally {
        Swal.close();
        this.isCalculandoImposto = false;
      }
    },
    async show(type, item) {
      await this.$bvModal.show('modal_novo_itens');
      this.$root.$emit('modal:opened');
      this.$root.$emit('modal:sync-items');
      await this.getMarcaPedido();

      if (type === 'editar') {
        this.selected_cod_marca = await item.item.cod_marca;
        await this.getCategoriaPedido().then(() => {
          this.selected_cod_marca = item.item.cod_marca;
          this.selected_categoria = item.item.cod_categ;
        });

        await this.buscarReferencias().then(() => {
          this.selected_referencia = item.item.cod_referencia;
        });
        await this.buscaCorGradeItens(item.subItens);
      }
    },
    async resetModal() {
      this.tipoBusca = 'marca-categoria';
      this.selected_cod_marca = null;
      this.selected_categoria = null;
      this.selected_referencia = null;
      this.selected_embalagem = null;
      this.valorUnitario = null;
      this.busca_referencia = '';
      this.codigo_referencia_direto = '';
      this.clearModalItens();
      this.novosItensAdicionados = false;
      this.itensTabela = [];

      // this.itensTabela = (this.getItensPedido || []).flatMap(item => {
      //   return (item.itens || []).map(subitem => ({
      //     ...subitem,
      //     codMarca: item.CodMarca,
      //     familiaComercialId: item.CodReferencia,
      //     marca: item.DescricaoMarca,
      //     descricao_referencia: item.DescricaoReferencia,
      //     precoUnitario: subitem.precoUnitario,
      //     precoComImposto: subitem.precoComImposto,
      //     valorTotal: subitem.valorTotal,
      //     pedidoItemQuantidade: subitem.pedidoItemQuantidade,
      //     embalagem: subitem.embalagem,
      //     cdn_embalagem: subitem.cdn_embalagem,
      //     des_cor: subitem.des_cor,
      //     cdn_cor: subitem.cdncor,
      //     tamanho: subitem.desc_tamanho,
      //     item_id: subitem.itemId,
      //     nome: subitem.item_descricao,
      //     valor: subitem.pedidoItemQuantidade,
      //   }));
      // });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.addItens();
      this.handleSubmit();
      this.clearModalItens();
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn');
      });
    },
    handleRemoveItem(item) {
      console.log('REMOVENDO ITEM', item);
      this.itensTabela = this.itensTabela.filter((i) => i.itemId !== item.item_id && i.pedidoItemQuantidade !== item.valor);
      console.log('TABELA ATUAL', this.itensTabela);

      this.novosItensAdicionados = this.itensTabela.length > 0;
    },
    async updatedGradeItens(value) {
      console.log('updatedGradeItens', value);

      if (!value || value.length === 0) return;

      const novoItem = value[value.length - 1];
      const itemMultiplo = parseInt(novoItem.itemMultiplo || 1);

      // Verificar se a quantidade é múltipla quando itemMultiplo > 1
      if (itemMultiplo > 1) {
        const quantidade = parseInt(novoItem.valor, 10);
        if (quantidade % itemMultiplo !== 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Quantidade inválida',
              text: `A quantidade deve ser múltipla de ${itemMultiplo}`,
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
      }

      // Verificar se o item já existe na tabela
      const itemExistente = this.itensTabela.find((item) => item.itemId === novoItem.item_id
        && item.des_cor === novoItem.des_cor
        && item.desc_tamanho === novoItem.tamanho
        && item.cdn_embalagem === novoItem.cdn_embalagem);

      if (itemExistente) {
        // Se o item já existe, apenas atualizar a quantidade
        const valorAntigo = itemExistente.pedidoItemQuantidade;
        const novaQuantidade = parseInt(novoItem.valor);

        // Verificar se a nova quantidade é múltiplo válido
        const itemMultiplo = parseInt(itemExistente.itemMultiplo || 1);

        if (itemMultiplo > 1) {
          if (novaQuantidade % itemMultiplo !== 0) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Quantidade inválida',
                text: `A quantidade deve ser múltipla de ${itemMultiplo}`,
                icon: 'AlertTriangleIcon',
                variant: 'warning',
              },
            });
            return;
          }
        }

        itemExistente.pedidoItemQuantidade = novaQuantidade;
        itemExistente.valorTotal = novaQuantidade * itemExistente.precoUnitario;
        itemExistente.valorTotalComImposto = novaQuantidade * (itemExistente.precoComImposto || itemExistente.precoUnitario);
      } else {
        // Se é um novo item, tentar usar pré-simulação existente
        const precoBase = parseFloat(novoItem.item_price_base || novoItem.precoUnitario || novoItem.item_price || 0);
        let precoExibicao = parseFloat(novoItem.item_price || novoItem.precoComImposto || novoItem.precoUnitario || precoBase);

        let precoComImposto = novoItem.precoComImposto ? parseFloat(novoItem.precoComImposto) : null;
        let baseIcms = novoItem.baseIcms || null;
        let valorIcms = novoItem.valorIcms || null;
        let naturezaoperacaoidimposto = novoItem.naturezaoperacaoidimposto || null;

        if (!precoComImposto) {
          const impostos = await this.calcularImposto({
            item_id: novoItem.item_id,
            precoUnitario: precoBase,
            valor: 1,
          });
          if (impostos) {
            precoComImposto = parseFloat(impostos.precoComImposto);
            baseIcms = impostos.baseIcms;
            valorIcms = impostos.valorIcms;
            naturezaoperacaoidimposto = impostos.naturezaoperacaoidimposto;
            precoExibicao = precoComImposto || precoExibicao;
          }
        }

        const quantidade = parseInt(novoItem.valor, 10);

        const newItem = {
          codMarca: this.selected_cod_marca,
          familiaComercialId: novoItem.referencia,
          cdncor: novoItem.cdn_cor,
          des_cor: novoItem.des_cor,
          cdn_tamanho: novoItem.tamanho,
          itemId: novoItem.item_id,
          item_id: novoItem.item_id,
          item_descricao: `${novoItem.nome} ${novoItem.tamanho} ${novoItem.des_cor}`,
          descricao_referencia: novoItem.nome,
          pedidoItemQuantidade: quantidade,
          marca: novoItem.marca,
          embalagem: novoItem.embalagem,
          cdn_embalagem: novoItem.cdn_embalagem,
          precoUnitarioBase: precoBase,
          precoUnitario: precoExibicao,
          precoComImposto: precoComImposto || null,
          baseIcms,
          valorIcms,
          naturezaoperacaoidimposto,
          valorTotal: precoBase * quantidade,
          valorTotalComImposto: (precoComImposto || precoExibicao) * quantidade,
          desc_tamanho: novoItem.tamanho,
          tamanho: novoItem.tamanho,
          pedidoItemQuantidadeSaldo: 0,
          pedidoItemQuantidadeFaturada: 0,
          pedidoitemseq: 0,
          itemMultiplo: novoItem.itemMultiplo || 1,
          novoItem: true,
        };

        this.itensTabela.push(newItem);
      }

      this.novosItensAdicionados = this.itensTabela.length > 0;
    },
    async addItens() {
      console.log('addItens', this.itensTabela);

      const itensAgrupadosPorReferencia = this.itensTabela.reduce((acc, item) => {
        const referencia = item.familiaComercialId;
        if (!acc[referencia]) {
          acc[referencia] = {
            CodMarca: item.codMarca,
            DescricaoMarca: item.marca,
            CodReferencia: referencia,
            DescricaoReferencia: item.descricao_referencia,
            referencia: `${referencia}-${item.item_descricao}`,
            Qtde: 0,
            PrecoUnitario: item.precoUnitarioBase || item.precoUnitario,
            ValorTotal: 0,
            PrecoComImposto: item.precoComImposto || item.precoUnitario || 0,
            BaseIcms: 0,
            ValorIcms: 0,
            sequencia: Object.keys(acc).length + 1,
            itens: [],
            editar: {
              cod_marca: item.codMarca,
              cod_categ: this.selected_categoria,
              cod_referencia: referencia,
              precoId: this.getCapaPedido.tabelaprecoid,
            },
          };
        }
        acc[referencia].Qtde += item.pedidoItemQuantidade;
        acc[referencia].ValorTotal += item.pedidoItemQuantidade * (item.precoUnitarioBase || item.precoUnitario);
        acc[referencia].BaseIcms += (item.baseIcms || 0) * item.pedidoItemQuantidade;
        acc[referencia].ValorIcms += (item.valorIcms || 0) * item.pedidoItemQuantidade;
        acc[referencia].valorTotalComImposto = (item.precoComImposto || item.precoUnitario || item.precoUnitarioBase) * item.pedidoItemQuantidade;

        acc[referencia].itens.push({
          ...item,
          precoComImposto: item.precoComImposto || item.precoUnitario || 0,
          baseIcms: item.baseIcms || 0,
          valorIcms: item.valorIcms || 0,
          valorTotalComImposto: (item.precoComImposto || item.precoUnitario || item.precoUnitarioBase) * item.pedidoItemQuantidade,
          naturezaoperacaoidimposto: item.naturezaoperacaoidimposto,
        });

        return acc;
      }, {});

      console.log('itensAgrupadosPorReferencia com impostos', itensAgrupadosPorReferencia);

      for (const referencia in itensAgrupadosPorReferencia) {
        const item = itensAgrupadosPorReferencia[referencia];
        await this.setItensTabelaPedido(item);
      }
    },
  },
  computed: {
    totalValor() {
      return this.itensTabela.reduce((sum, item) => sum + ((item.precoComImposto || item.precoUnitario || item.precoUnitarioBase) * item.pedidoItemQuantidade), 0);
    },
    totalUnidades() {
      return this.itensTabela.reduce((sum, item) => sum + item.pedidoItemQuantidade, 0);
    },
    ...mapGetters('intensPedido', [
      'getEsMarcas',
      'getIsLoadingMarca',
      'getEsCategorias',
      'getIsLoadingCategoria',
      'getEsReferencias',
      'getIsLoadingReferencia',
      'getEsEmbalagens',
      'getIsLoadingEmbalagem',
      'getFormData',
      'getlistarTabelaItens',
    ]),
    ...mapGetters('SLS_PedidosVendas', [
      'getCapaPedido',
      'getItensPedido',
      'getEnderecoEntrega',
    ]),
  },
};
</script>

<style scoped>
.container-images-prod {
  width: 500px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
}

.modal-add-product {
  --map-primary: var(--sf-accent, #7367f0);
}

.client-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sf-accent, #7367f0);
  color: white;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;

  .client-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    feather-icon {
      opacity: 0.9;
    }
  }

  .order-info {
    display: flex;
    gap: 1.5rem;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    line-height: 1.1;

    .label {
      font-size: 0.65rem;
      opacity: 0.8;
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .value {
      font-size: 0.85rem;
      font-weight: 600;
      color: white;
    }
  }
}

.modal-actions-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--sf-border-color, #e2e8f0);

  .items-summary {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: var(--sf-surface-secondary, #f8fafc);
    border-radius: 6px;

    .summary-count {
      font-weight: 600;
      color: var(--sf-accent, #7367f0);
      font-size: 0.9rem;
    }

    .summary-separator {
      color: var(--sf-border-color, #cbd5e1);
    }

    .summary-total {
      font-weight: 600;
      color: var(--sf-text-primary, #334155);
    }
  }

  .actions-buttons {
    display: flex;
    gap: 0.75rem;
  }
}

:global(body.dark-layout) {
  .client-info-bar {
    background: var(--sf-accent-dark, #5e50ee);
  }
}
</style>
